(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const mq = window.matchMedia('(min-width: 640px)');
    const sync = () => document.querySelectorAll('.footer__group').forEach((d) => { if (mq.matches) d.open = true; });
    sync();
    mq.addEventListener('change', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const saveData = navigator.connection && navigator.connection.saveData;
      if (!motionOk || saveData) return;

      const clips = Array.from(root.querySelectorAll('[data-hero-clip]'));
      const videos = clips.map((c) => c.querySelector('video'));
      if (!videos[0]) return;
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      const load = (v) => {
        if (!v || v.src) return;
        v.src = mobile ? v.dataset.srcMobile : v.dataset.srcDesktop;
        v.preload = 'auto';
      };
      videos.forEach((v) => v && v.addEventListener('playing', () => v.classList.add('is-playing')));

      const single = clips.length < 2 || videos.some((v) => !v);
      let index = 0;
      let switching = false;
      const next = () => {
        if (switching) return;
        switching = true;
        const prev = index;
        index = (index + 1) % clips.length;
        const v = videos[index];
        load(v);
        v.currentTime = 0;
        v.play().catch(() => {});
        clips[index].classList.add('is-active');
        clips[prev].classList.remove('is-active');
        setTimeout(() => {
          videos[prev].pause();
          videos[prev].currentTime = 0;
          switching = false;
        }, 950);
      };
      if (single) {
        videos[0].loop = true;
      } else {
        videos.forEach((v, i) => {
          v.addEventListener('timeupdate', () => {
            if (i !== index || !v.duration) return;
            // Préchargement du clip suivant à mi-parcours seulement.
            if (v.currentTime > v.duration / 2) load(videos[(i + 1) % videos.length]);
            if (v.duration - v.currentTime <= 0.9) next();
          });
          v.addEventListener('ended', () => i === index && next());
        });
      }

      // Pause quand le hero sort de l'écran.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          const v = videos[index];
          if (!v || !v.src) return;
          if (entry.isIntersecting) v.play().catch(() => {});
          else v.pause();
        }).observe(root);
      }

      // Un onglet masqué ne lance pas la vidéo : reprise au retour sur l'onglet.
      document.addEventListener('visibilitychange', () => {
        const v = videos[index];
        if (document.visibilityState === 'visible' && v && v.src && v.paused) v.play().catch(() => {});
      });

      const start = () => {
        load(videos[0]);
        videos[0].play().catch(() => {});
      };
      const whenIdle = () => ('requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 2000 }) : setTimeout(start, 200));
      if (document.readyState === 'complete') whenIdle();
      else window.addEventListener('load', whenIdle, { once: true });
    };
    document.querySelectorAll('[data-hero]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-hero]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-subcats-toggle]');
    if (!btn) return;
    const open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(open));
    btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    btn.parentElement.querySelectorAll('.subcats__extra').forEach((li) => (li.hidden = !open));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const { $, $$, openModal, Cart } = window.LRDF;
      const data = JSON.parse(document.querySelector('[data-product-json]').textContent);
      const form = $('[data-product-form]', root);
      const idInput = $('[data-variant-id]', form);
      const addBtn = $('[data-add]', form);
      const addLabel = $('[data-add-label]', form);
      const error = $('[data-error]', form);
      const sizePicker = $('#size-picker', root);
      const sticky = document.querySelector('[data-sticky-atc]');

      // Sans choix explicite de taille (plusieurs tailles), l'acheteuse doit en choisir une.
      const needsSize = !!sizePicker && !new URLSearchParams(location.search).has('variant');
      let sizeChosen = !needsSize;
      if (needsSize) $$('input[type="radio"]', sizePicker).forEach((i) => (i.checked = false));

      const selected = () => {
        const values = [];
        $$('[data-option]', form).forEach((input) => {
          const i = Number(input.dataset.option);
          if (input.type === 'hidden' || input.checked) values[i] = input.value;
        });
        return values;
      };
      const findVariant = (values) => data.variants.find((v) => v.options.every((o, i) => values[i] === undefined || values[i] === o));

      const refreshAvailability = (values) => {
        $$('[data-option-group]', form).forEach((group) => {
          const index = Number(group.dataset.optionGroup);
          $$('input[type="radio"]', group).forEach((input) => {
            const test = [...values];
            test[index] = input.value;
            const ok = data.variants.some((v) => v.available && v.options.every((o, i) => test[i] === undefined || test[i] === o));
            const span = input.nextElementSibling;
            if (span && span.classList.contains('option__btn')) span.classList.toggle('is-unavailable', !ok);
          });
          const checked = $('input:checked', group);
          const label = $('[data-option-value]', group);
          if (label) label.textContent = checked ? `— ${checked.value === 'TU' ? 'Taille unique' : checked.value}` : '';
        });
      };

      const update = () => {
        const values = selected();
        const variant = findVariant(values);
        refreshAvailability(values);
        if (!variant) return;
        idInput.value = variant.id;
        $('[data-price-wrap] .price', root).outerHTML = variant.priceHtml;
        const available = variant.available;
        addBtn.disabled = sizeChosen && !available;
        addLabel.textContent = sizeChosen && !available ? 'Épuisé' : 'Ajouter au panier';
        if (sizeChosen) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
        if (variant.mediaId) goTo($$('[data-slide]', root).findIndex((s) => Number(s.dataset.mediaId) === variant.mediaId));
        if (sticky) {
          $('[data-sticky-price]', sticky).textContent = (variant.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
          const size = data.sizeIndex === null ? '' : values[data.sizeIndex];
          $('[data-sticky-size]', sticky).textContent = sizePicker ? (sizeChosen && size ? `· ${size}` : '· taille à choisir') : '';
          $('[data-sticky-add]', sticky).textContent = sizeChosen || !sizePicker ? (available ? 'Ajouter' : 'Épuisé') : 'Choisir';
        }
      };

      form.addEventListener('change', (e) => {
        if (sizePicker && sizePicker.contains(e.target)) {
          sizeChosen = true;
          error.hidden = true;
          sizePicker.classList.remove('option--error');
        }
        update();
      });

      const submit = async () => {
        if (!sizeChosen) {
          error.hidden = false;
          sizePicker.classList.add('option--error');
          sizePicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        addBtn.disabled = true;
        try {
          await Cart.add([{ id: Number(idInput.value), quantity: 1 }]);
          addLabel.textContent = 'Ajouté au panier';
          Cart.open();
          setTimeout(() => {
            addLabel.textContent = 'Ajouter au panier';
          }, 2200);
        } catch (err) {
          error.textContent = err.message;
          error.hidden = false;
        } finally {
          addBtn.disabled = false;
        }
      };
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        submit();
      });

      // Galerie
      const slides = $$('[data-slide]', root);
      const thumbs = $$('[data-thumb]', root);
      const dots = $$('.gallery__dots span', root);
      const track = $('[data-track]', root);
      const status = $('[data-gallery-status]', root);
      const desktop = window.matchMedia('(min-width: 768px)');
      let current = 0;
      function goTo(index, scroll = true) {
        if (index < 0 || index >= slides.length) return;
        current = index;
        slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
        if (status) status.textContent = `Photo ${index + 1} sur ${slides.length}`;
        if (scroll && !desktop.matches && track) track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
      }
      thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
      if (track) {
        let raf;
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(track.scrollLeft / track.clientWidth);
            if (i !== current) goTo(i, false);
          });
        });
      }
      const lightbox = document.querySelector('[data-lightbox]');
      slides.forEach((s) => s.addEventListener('click', () => {
        const img = $('img', s);
        if (!img || !lightbox) return;
        $('[data-lightbox-img]', lightbox).innerHTML = `<img src="${img.currentSrc || img.src}" alt="${img.alt}">`;
        openModal(lightbox);
      }));

      // Guide des tailles
      const guide = document.querySelector('[data-size-guide]');
      root.addEventListener('click', (e) => {
        if (e.target.closest('[data-size-guide-open]') && guide) openModal(guide);
      });

      // Barre collante mobile
      const cta = $('[data-main-cta]', root);
      if (sticky && cta && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.toggleAttribute('inert', !show);
          sticky.setAttribute('aria-hidden', String(!show));
        }).observe(cta);
        $('[data-sticky-add]', sticky).addEventListener('click', submit);
      }

      update();
    };
    const boot = () => document.querySelectorAll('[data-product]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (track) => {
      if (track.dataset.ready) return;
      track.dataset.ready = 'true';
      const dots = track.parentElement.querySelectorAll('[data-moods-dots] span');
      if (!dots.length) return;
      const cards = Array.from(track.children);
      const update = () => {
        const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
        const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        const best = atEnd ? cards.length - 1 : Math.round(track.scrollLeft / step);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === best));
      };
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('scrollend', update);
    };
    const boot = () => document.querySelectorAll('[data-moods-track]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const load = async (el) => {
      if (el.dataset.loaded) return;
      el.dataset.loaded = 'true';
      try {
        const res = await fetch(el.dataset.url);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('[data-recos]');
        if (fresh && fresh.querySelector('.product-grid')) {
          el.innerHTML = fresh.innerHTML;
          window.LRDF && window.LRDF.Wishlist.sync();
        }
      } catch (e) { /* pas de recommandations */ }
    };
    const boot = () => {
      const items = document.querySelectorAll('[data-recos]');
      if (!('IntersectionObserver' in window)) return items.forEach(load);
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) {
          io.unobserve(e.target);
          load(e.target);
        }
      }), { rootMargin: '0px 0px 400px 0px' });
      items.forEach((el) => io.observe(el));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = (cents) => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    const init = (root) => {
      const { Cart } = window.LRDF;
      const pieces = Array.from(root.querySelectorAll('[data-piece]')).map((el) => ({
        el,
        title: el.dataset.title,
        price: Number(el.dataset.price),
        sizeIndex: el.dataset.sizeIndex === '' ? null : Number(el.dataset.sizeIndex),
        variants: JSON.parse(el.querySelector('[data-variant-data]').textContent),
        soldout: el.hasAttribute('data-soldout'),
        on: !el.hasAttribute('data-soldout'),
        size: el.querySelector('[data-single-size]') ? '__single' : null,
      }));
      const totalEl = root.querySelector('[data-total]');
      const labelEl = root.querySelector('[data-total-label]');
      const cta = root.querySelector('[data-look-add]');
      const ctaLabel = root.querySelector('[data-cta-label]');
      const status = root.querySelector('[data-look-status]');
      const setStatus = (text, error = false) => {
        status.textContent = text;
        status.classList.toggle('is-error', error);
      };

      const refresh = () => {
        const selected = pieces.filter((p) => p.on);
        const all = selected.length === pieces.filter((p) => !p.soldout).length;
        totalEl.textContent = money(selected.reduce((s, p) => s + p.price, 0));
        totalEl.classList.remove('animate-fade-up');
        void totalEl.offsetWidth;
        totalEl.classList.add('animate-fade-up');
        labelEl.textContent = all ? 'Le look complet' : 'Votre sélection';
        ctaLabel.textContent = all ? 'Ajouter le look au panier' : 'Ajouter la sélection au panier';
        cta.disabled = selected.length === 0;
        if (!selected.length) setStatus('Sélectionnez au moins une pièce.');
      };

      pieces.forEach((p) => {
        const toggle = p.el.querySelector('[data-piece-toggle]');
        p.el.classList.toggle('is-off', !p.on);
        toggle.addEventListener('click', () => {
          p.on = !p.on;
          toggle.setAttribute('aria-checked', String(p.on));
          p.el.classList.toggle('is-off', !p.on);
          refresh();
        });
        p.el.querySelectorAll('[data-size]').forEach((btn) => {
          btn.addEventListener('click', () => {
            p.size = btn.dataset.size;
            p.el.querySelectorAll('[data-size]').forEach((b) => {
              b.setAttribute('aria-checked', String(b === btn));
              b.classList.remove('is-error');
            });
            setStatus('Chaque pièce est aussi disponible séparément.');
          });
        });
      });

      const variantFor = (p) => {
        if (p.size === '__single' || p.sizeIndex === null) return p.variants.find((v) => v.available);
        return p.variants.find((v) => v.available && v.options[p.sizeIndex] === p.size);
      };

      cta.addEventListener('click', async () => {
        const selected = pieces.filter((p) => p.on);
        const missing = selected.find((p) => !p.size);
        if (missing) {
          missing.el.querySelectorAll('[data-size]').forEach((b) => b.classList.add('is-error'));
          setStatus(`Choisissez une taille pour ${missing.title}.`, true);
          return;
        }
        const items = [];
        for (const p of selected) {
          const v = variantFor(p);
          if (!v) {
            setStatus(`${p.title} n'a pas pu être ajouté.`, true);
            return;
          }
          items.push({ id: v.id, quantity: 1 });
        }
        cta.disabled = true;
        try {
          await Cart.add(items);
          ctaLabel.textContent = `${items.length} article${items.length > 1 ? 's' : ''} ajouté${items.length > 1 ? 's' : ''}`;
          Cart.open();
          setTimeout(refresh, 2400);
        } catch (err) {
          setStatus(err.message, true);
        } finally {
          cta.disabled = false;
        }
      });

      refresh();
      setStatus('Chaque pièce est aussi disponible séparément.');
    };
    const initSection = (section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const panels = Array.from(section.querySelectorAll('[data-look]'));
      panels.forEach(init);
      const show = (index, focus = false) => {
        panels.forEach((panel, i) => (panel.hidden = i !== index));
        if (focus) {
          const dot = panels[index].querySelector(`[data-look-go="${index}"]`);
          if (dot) dot.focus({ preventScroll: true });
        }
      };
      section.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-look-go]');
        if (dot) show(Number(dot.dataset.lookGo), true);
      });
      section.addEventListener('keydown', (e) => {
        if (!e.target.closest('[data-look-go]') || !['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
        const current = panels.findIndex((p) => !p.hidden);
        const next = (current + (e.key === 'ArrowRight' ? 1 : panels.length - 1)) % panels.length;
        show(next, true);
      });
      // Balayage horizontal sur la photo (mobile)
      let x0 = null;
      section.addEventListener('touchstart', (e) => {
        if (e.target.closest('.look__photo')) x0 = e.touches[0].clientX;
      }, { passive: true });
      section.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) < 50 || panels.length < 2) return;
        const current = panels.findIndex((p) => !p.hidden);
        show((current + (dx < 0 ? 1 : panels.length - 1)) % panels.length);
      });
      // Éditeur de thème : afficher le look sélectionné
      document.addEventListener('shopify:block:select', (e) => {
        const i = panels.indexOf(e.target);
        if (i > -1) show(i);
      });
    };
    const boot = () => document.querySelectorAll('[data-looks]').forEach(initSection);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-looks]').forEach(initSection));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  (() => {
    const b64encode = (str) => btoa(String.fromCharCode(...new TextEncoder().encode(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    const b64decode = (str) => {
      const s = str.replace(/-/g, '+').replace(/_/g, '/');
      const bin = atob(s + '='.repeat((4 - (s.length % 4)) % 4));
      return new TextDecoder().decode(Uint8Array.from(bin, (c) => c.charCodeAt(0)));
    };
    const plural = (n, word) => `${n} ${word}${n > 1 ? 's' : ''}`;

    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const { $, $$, openModal, closeModal, Wishlist } = window.LRDF;
      const productsBase = window.theme.routes.products;
      const cache = new Map();
      const grid = $('[data-wl-grid]', root);
      const empty = $('[data-wl-empty]', root);
      let current = 'all';

      const fetchCard = async (handle) => {
        if (cache.has(handle)) return cache.get(handle);
        const p = fetch(`${productsBase}/${encodeURIComponent(handle)}?view=card`)
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.querySelector('.card') ? doc.querySelector('.card').outerHTML : '';
          })
          .catch(() => '');
        cache.set(handle, p);
        return p;
      };

      const renderGrid = async (handles, { owner = true } = {}) => {
        grid.setAttribute('aria-busy', 'true');
        const cards = await Promise.all(handles.map(fetchCard));
        const valid = cards.filter(Boolean);
        grid.innerHTML = valid.join('');
        grid.removeAttribute('aria-busy');
        $$('[data-wishlist-remove]', grid).forEach((b) => (b.hidden = !owner || current === 'all'));
        $$('.card__actions', grid).forEach((a) => (a.hidden = !owner));
        Wishlist.sync();
        return valid.length;
      };

      /* ---------- Vue partagée (?l=…) ---------- */
      const shared = new URLSearchParams(location.search).get('l');
      if (shared) {
        $('[data-wl-owner]', root).hidden = true;
        let name = 'Mes envies';
        let handles = [];
        try {
          const [n, list] = b64decode(shared).split('|');
          name = n.trim() || name;
          handles = (list || '').split(',').filter((h) => /^[a-z0-9-]+$/.test(h)).slice(0, 24);
        } catch (e) { /* lien invalide */ }
        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex, nofollow';
        document.head.append(meta);
        $('[data-wl-title]', root).textContent = name;
        $('[data-wl-crumb]', root).textContent = 'Sélection partagée';
        $('[data-wl-desc]', root).textContent = 'Une sélection partagée avec vous.';
        renderGrid(handles, { owner: false }).then((count) => {
          $('[data-wl-count]', root).textContent = plural(count, 'pièce');
          if (count) {
            $('[data-wl-shared-note]', root).hidden = false;
          } else {
            $('[data-wl-title]', root).textContent = "Cette sélection n'est plus disponible";
            $('[data-wl-desc]', root).textContent = 'Le lien est incomplet, ou les pièces ne sont plus en boutique. Demandez un nouveau lien, ou parcourez la boutique.';
            empty.hidden = false;
            $('[data-wl-empty-title]', root).hidden = true;
            $('[data-wl-empty-text]', root).hidden = true;
          }
        });
        return;
      }

      /* ---------- Vue propriétaire ---------- */
      const listById = (id) => Wishlist.lists.find((l) => l.id === id);
      const handlesFor = (id) => (id === 'all' ? Wishlist.all() : (listById(id) || { handles: [] }).handles);

      const renderTabs = () => {
        const tabs = $('[data-wl-tabs]', root);
        const items = [{ id: 'all', name: 'Tous', count: Wishlist.all().length }, ...Wishlist.lists.map((l) => ({ id: l.id, name: l.name, count: l.handles.length }))];
        tabs.innerHTML = '';
        items.forEach((item) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'wl__tab';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-selected', String(item.id === current));
          b.dataset.tab = item.id;
          b.textContent = item.name;
          const small = document.createElement('small');
          small.textContent = item.count;
          b.append(small);
          tabs.append(b);
        });
        const add = document.createElement('button');
        add.type = 'button';
        add.className = 'wl__tab';
        add.dataset.wlNew = '';
        add.textContent = '+ Nouvelle liste';
        tabs.append(add);
      };

      const render = async () => {
        if (current !== 'all' && !listById(current)) current = 'all';
        const handles = handlesFor(current);
        const list = listById(current);
        renderTabs();
        $('[data-wl-count]', root).textContent = plural(Wishlist.all().length, 'pièce');
        $('[data-wl-n]', root).textContent = plural(handles.length, 'pièce');
        const actions = $('[data-wl-actions]', root);
        actions.hidden = current === 'all';
        $('[data-wl-share]', root).disabled = !handles.length;
        if (list) {
          $('[data-wl-rename]', root).hidden = list.isDefault;
          $('[data-wl-delete]', root).hidden = list.isDefault;
          $('[data-wl-clear]', root).disabled = !handles.length;
        }
        const count = await renderGrid(handles);
        empty.hidden = count > 0;
        $('[data-wl-empty-title]', root).textContent = list ? `« ${list.name} » est encore vide` : 'Votre liste est encore vide';
      };

      /* Dialogues */
      const nameDialog = $('[data-wl-name-dialog]', root);
      const nameInput = $('[data-wl-name-input]', root);
      let nameMode = 'create';
      const openNameDialog = (mode) => {
        nameMode = mode;
        const list = listById(current);
        $('[data-wl-name-title]', root).textContent = mode === 'create' ? 'Créer une liste' : 'Renommer la liste';
        $('[data-wl-name-desc]', root).hidden = mode !== 'create';
        $('[data-wl-name-submit]', root).textContent = mode === 'create' ? 'Créer la liste' : 'Enregistrer';
        nameInput.value = mode === 'rename' && list ? list.name : '';
        openModal(nameDialog, { initialFocus: '[data-wl-name-input]' });
      };
      $('[data-wl-name-form]', root).addEventListener('submit', (e) => {
        e.preventDefault();
        if (nameMode === 'create') {
          const list = Wishlist.create(nameInput.value);
          if (list) current = list.id;
        } else {
          Wishlist.rename(current, nameInput.value);
        }
        closeModal(nameDialog);
        render();
      });

      const confirmDialog = $('[data-wl-confirm]', root);
      let confirmAction = null;
      const confirm = (title, desc, ok, action) => {
        $('[data-wl-confirm-title]', root).textContent = title;
        $('[data-wl-confirm-desc]', root).textContent = desc;
        $('[data-wl-confirm-ok]', root).textContent = ok;
        confirmAction = action;
        openModal(confirmDialog);
      };
      $('[data-wl-confirm-ok]', root).addEventListener('click', () => {
        closeModal(confirmDialog);
        if (confirmAction) confirmAction();
        render();
      });

      const orgDialog = $('[data-wl-organize]', root);
      let orgHandle = null;
      let orgSelection = [];
      const renderOrgList = () => {
        const ul = $('[data-wl-org-list]', root);
        ul.innerHTML = '';
        Wishlist.lists.forEach((l) => {
          const li = document.createElement('li');
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'checkbox');
          b.setAttribute('aria-checked', String(orgSelection.includes(l.id)));
          b.innerHTML = '<span class="check"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg></span>';
          b.append(document.createTextNode(l.name));
          const small = document.createElement('small');
          small.textContent = l.handles.length;
          b.append(small);
          b.addEventListener('click', () => {
            orgSelection = orgSelection.includes(l.id) ? orgSelection.filter((x) => x !== l.id) : [...orgSelection, l.id];
            renderOrgList();
          });
          li.append(b);
          ul.append(li);
        });
      };
      $('[data-wl-org-new]', root).addEventListener('click', () => {
        $('[data-wl-org-create]', root).hidden = false;
        $('[data-wl-org-input]', root).focus();
      });
      $('[data-wl-org-add]', root).addEventListener('click', () => {
        const list = Wishlist.create($('[data-wl-org-input]', root).value);
        if (list) orgSelection.push(list.id);
        $('[data-wl-org-input]', root).value = '';
        $('[data-wl-org-create]', root).hidden = true;
        renderOrgList();
      });
      $('[data-wl-org-save]', root).addEventListener('click', () => {
        Wishlist.setMembership(orgHandle, orgSelection);
        closeModal(orgDialog);
        render();
      });

      const shareDialog = $('[data-wl-share-dialog]', root);
      const openShare = () => {
        const list = listById(current);
        if (!list) return;
        const handles = list.handles.slice(0, 24);
        const url = `${location.origin}${location.pathname}?l=${b64encode(`${list.name}|${handles.join(',')}`)}`;
        $('[data-wl-share-name]', root).textContent = list.name;
        $('[data-wl-share-url]', root).value = url;
        $('[data-wl-share-status]', root).textContent = list.handles.length > 24 ? 'Les 24 pièces les plus récentes sont partagées.' : '';
        const qrBox = $('[data-wl-qr]', root);
        qrBox.innerHTML = '';
        if (window.qrcode) {
          const qr = window.qrcode(0, 'M');
          qr.addData(url, 'Byte');
          qr.make();
          qrBox.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 4, scalable: true });
          const svg = $('svg', qrBox);
          if (svg) {
            svg.querySelectorAll('rect').forEach((r) => r.setAttribute('fill', getComputedStyle(document.documentElement).getPropertyValue('--color-surface').trim() || '#fff'));
            svg.querySelectorAll('path').forEach((p) => p.setAttribute('fill', getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#000'));
          }
        }
        const native = $('[data-wl-native]', root);
        native.hidden = !navigator.share;
        native.onclick = () => navigator.share({ title: `Ma sélection — ${list.name}`, text: 'Voici ma sélection.', url }).catch(() => {});
        openModal(shareDialog);
      };
      $('[data-wl-copy]', root).addEventListener('click', async (e) => {
        const input = $('[data-wl-share-url]', root);
        try {
          await navigator.clipboard.writeText(input.value);
        } catch (err) {
          input.select();
          document.execCommand('copy');
        }
        e.target.textContent = 'Copié';
        $('[data-wl-share-status]', root).textContent = 'Lien copié.';
        setTimeout(() => (e.target.textContent = 'Copier'), 2400);
      });

      /* Menu « … » */
      const menu = $('[data-wl-menu]', root);
      const menuToggle = $('[data-wl-menu-toggle]', root);
      const closeMenu = () => {
        menu.hidden = true;
        menuToggle.setAttribute('aria-expanded', 'false');
      };
      menuToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        menu.hidden = !menu.hidden;
        menuToggle.setAttribute('aria-expanded', String(!menu.hidden));
      });
      document.addEventListener('click', (e) => !menu.contains(e.target) && closeMenu());

      /* Clics */
      root.addEventListener('click', (e) => {
        const tab = e.target.closest('[data-tab]');
        if (tab) {
          current = tab.dataset.tab;
          render();
          return;
        }
        if (e.target.closest('[data-wl-new]')) return openNameDialog('create');
        if (e.target.closest('[data-wl-share]')) return openShare();
        if (e.target.closest('[data-wl-rename]')) {
          closeMenu();
          return openNameDialog('rename');
        }
        if (e.target.closest('[data-wl-clear]')) {
          closeMenu();
          const list = listById(current);
          const n = list.handles.length;
          return confirm('Vider cette liste ?', n > 1 ? `Les ${n} pièces seront retirées de « ${list.name} ».` : `La pièce sera retirée de « ${list.name} ».`, 'Vider la liste', () => Wishlist.clear(list.id));
        }
        if (e.target.closest('[data-wl-delete]')) {
          closeMenu();
          const list = listById(current);
          return confirm('Supprimer cette liste ?', `« ${list.name} » sera supprimée. Les pièces qu'elle contient restent dans vos autres listes si vous les y avez rangées.`, 'Supprimer', () => {
            Wishlist.remove(list.id);
            current = 'all';
          });
        }
        const remove = e.target.closest('[data-wishlist-remove]');
        if (remove) {
          Wishlist.removeFrom(current, remove.dataset.wishlistRemove);
          return render();
        }
        const organize = e.target.closest('[data-wishlist-organize]');
        if (organize) {
          orgHandle = organize.dataset.wishlistOrganize;
          orgSelection = Wishlist.lists.filter((l) => l.handles.includes(orgHandle)).map((l) => l.id);
          $('[data-wl-org-product]', root).textContent = organize.dataset.productTitle || '';
          $('[data-wl-org-create]', root).hidden = true;
          renderOrgList();
          openModal(orgDialog);
        }
      });

      // Un cœur retiré depuis la grille met la page à jour.
      document.addEventListener('wishlist:change', () => {
        if (!document.querySelector('.dialog:not([hidden])')) render();
      });

      render();
    };

    const boot = () => document.querySelectorAll('[data-wishlist-page]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
